import { apiFetch } from "./client";

export type DashboardKpis = {
  total_bookings: number;
  bookings_current_year: number;
  open_inquiries: number;
};

export type DashboardTaskKey =
  | "neue_anfragen"
  | "bestaetigung_offen"
  | "konus_link_offen"
  | "konus_daten_offen"
  | "infos_gruppe_offen"
  | "abreise_pruefen"
  | "anzahlung_offen"
  | "storno_rechnung_offen"
  | "rechnung_offen"
  | "rechnung_eingang_offen";

export type DashboardTaskSection = "buchung" | "rechnung";

export type DashboardTask = {
  key: DashboardTaskKey;
  title: string;
  subtitle: string | null;
  count: number;
  target: string;
  section: DashboardTaskSection;
};

export type UpcomingBooking = {
  id: number;
  gastname: string;
  gruppenname: string;
  einheiten_namen: string[];
  check_in: string;
  check_out: string;
  status: string;
  personen_gesamt: number;
  naechte: number;
};

export function fetchKpis() {
  return apiFetch<DashboardKpis>("/api/dashboard/kpis");
}

export function fetchTasks() {
  return apiFetch<DashboardTask[]>("/api/dashboard/tasks");
}

export function fetchUpcoming(limit = 5) {
  return apiFetch<UpcomingBooking[]>(`/api/dashboard/upcoming?limit=${limit}`);
}

export type DashboardConflicts = {
  count: number;
  booking_ids: number[];
  first_einheit: string | null;
  first_zeitraum: string | null;
};

export function fetchConflicts() {
  return apiFetch<DashboardConflicts>("/api/dashboard/conflicts");
}
